let dataLoader = () => {
  let data = null;
  let isLoading = false;
  let isLoaded = false;
  // Event listeners storage
  const eventListeners = {};

   // Event emission methods
  const addEventListener = (eventType, callback) => {
    if (!eventListeners[eventType]) {
      eventListeners[eventType] = [];
    }
    eventListeners[eventType].push(callback);
  };

  const removeEventListener = (eventType, callback) => {
    if (eventListeners[eventType]) {
      eventListeners[eventType] = eventListeners[eventType].filter(cb => cb !== callback);
    }
  };

  const emit = (eventType, eventData) => {
    if (eventListeners[eventType]) {
      eventListeners[eventType].forEach(callback => {
        try {
          callback(eventData);
        } catch (error) {
          console.error(`Error in event listener for ${eventType}:`, error);
        }
      });
    }
  };

  //  Charge un fichier CSV
  const loadCSV = async (csvFileName) => {
    console.log(`Début du chargement du fichier CSV: ${csvFileName}`);
    let data = null;
    let isLoading = false;
    let isLoaded = false;

    try {
      const response = await fetch(csvFileName);
      if (!response.ok) {
        throw new Error(`Impossible de charger le fichier CSV: ${response.status} ${response.statusText}`);
      }

      if (isLoaded) return Promise.resolve(data);
      if (isLoading) return waitUntilLoaded(isLoaded, data);

      isLoading = true;

      const csvData = await unarchive(response);

      // Mark as loaded
      data = csvData;
      isLoaded = true;
      isLoading = false;

      // Emit CSV loaded event
      emit("csvLoaded", {
        fileName: csvFileName,
        data: csvData,
        timestamp: new Date().toISOString()
      });
      return csvData;

    } catch (error) {
      console.error(`Erreur lors du chargement du fichier CSV ${csvFileName}:`, error);

      // Emit error event
      emit("csvError", {
        fileName: csvFileName,
        error: error.message,
        timestamp: new Date().toISOString()
      });

      throw error;
    }
  };

  // Charge un fichier JSON
  const loadJSON = async (jsonFileName) => {
   /* let data = null;
    let isLoading = false;
    let isLoaded = false;*/

    console.log(`Début du chargement du fichier JSON: ${jsonFileName}`);
    try {
      const response = await fetch(jsonFileName);
      if (!response.ok) {
        throw new Error(`Impossible de charger le fichier JSON: ${response.status} ${response.statusText}`);
      }

      if (isLoaded) return Promise.resolve(data);
      if (isLoading) return waitUntilLoaded(isLoaded, data);

      isLoading = true;

      const jsonData = await unarchive(response);

      // Mark as loaded
      data = JSON.parse(jsonData);
      isLoaded = true;
      isLoading = false;

      // Emit JSON loaded event
      emit("jsonLoaded", {
        fileName: jsonFileName,
        data: jsonData,
        timestamp: new Date().toISOString()
      });
      return jsonData;

    } catch (error) {
        console.error(`Erreur lors du chargement du fichier JSON ${jsonFileName}:`, error);

        // Emit error event
        emit("jsonError", {
          fileName: jsonFileName,
          error: error.message,
          timestamp: new Date().toISOString()
        });

        throw error;
      }
    };

  const unarchive = async (response) => {
    const buffer = await response.arrayBuffer();
    const uint8Array = new Uint8Array(buffer);

    console.log(`Taille du fichier: ${buffer.byteLength} octets`);
    console.log(`En-tête du fichier: ${Array.from(uint8Array.slice(0, 4)).map(b => '0x' + b.toString(16).padStart(2, '0')).join(' ')}`);

    // Vérifier le magic number GZIP (1f 8b) et qu'il y a au moins 10 octets (taille minimale d'un header GZIP)
    const isGzipCompressed = uint8Array.length >= 10 && uint8Array[0] === 0x1f && uint8Array[1] === 0x8b;

    if (isGzipCompressed) {
      console.log('Fichier GZIP détecté, décompression en cours...');

      try {
        // Vérifier le support de DecompressionStream
        if (typeof DecompressionStream !== 'undefined') {
          console.log('Utilisation de DecompressionStream (API native)');

          // Méthode corrigée pour DecompressionStream
          const stream = new Response(uint8Array).body.pipeThrough(new DecompressionStream('gzip'));
          const decompressed = await new Response(stream).text();

          console.log(`Décompression réussie: ${decompressed.length} caractères`);
          return decompressed;

        } else {
          console.warn('DecompressionStream non supporté, utilisation de pako');

          // Fallback avec pako si disponible
          if (typeof pako !== 'undefined') {
            const decompressed = pako.inflate(uint8Array, { to: 'string' });
            console.log(`Décompression pako réussie: ${decompressed.length} caractères`);
            return decompressed;
          } else {
            throw new Error('Aucune méthode de décompression GZIP disponible');
          }
        }

      } catch (error) {
        console.error('Erreur lors de la décompression GZIP:', error);

        // Fallback: essayer de traiter comme texte brut
        console.warn('Tentative de lecture comme texte brut en fallback...');
        try {
          const fallbackText = new TextDecoder('utf-8', { fatal: false }).decode(uint8Array);
          if (fallbackText && fallbackText.length > 0 && !fallbackText.includes('\u0000')) {
            console.log('Fallback réussi');
            return fallbackText;
          }
        } catch (fallbackError) {
          console.error('Fallback échoué également:', fallbackError);
        }

        throw new Error(`Impossible de décompresser le fichier GZIP: ${error.message}`);
      }
    } else {
      // Fichier non compressé
      console.log('Fichier non compressé, lecture directe...');

      const decompressed = new TextDecoder('utf-8').decode(uint8Array);
      console.log(`Lecture directe réussie: ${decompressed.length} caractères`);
      return decompressed;
    }
  };

  const waitUntilLoaded = (isLoaded, data) => {
    return new Promise(resolve => {
      const check = () => {
        if (isLoaded) resolve(data);
        else setTimeout(check, 100);
      };
      check();
    });
  };

  // Optimized CSV parser with better performance
  const parseCSV = (csvText) => {
    if (!csvText?.trim()) return [];

    const lines = csvText.trim().split("\n");
    if (lines.length <= 1) return [];

    // Detect delimiter more efficiently
    const firstLine = lines[0];
    const delimiter = firstLine.includes(";") ? ";" : ",";

    // Pre-compile regex for better performance
    const quoteRegex = /"/g;

    const parseCSVLine = (line) => {
      const values = [];
      let inQuotes = false;
      let currentValue = "";

      for (let i = 0; i < line.length; i++) {
        const char = line[i];

        if (char === "\"") {
          inQuotes = !inQuotes;
        } else if (char === delimiter && !inQuotes) {
          values.push(currentValue.trim());
          currentValue = "";
        } else {
          currentValue += char;
        }
      }

      values.push(currentValue.trim());
      return values.map(v => v.replace(quoteRegex, "").trim());
    };

    const rawHeaders = parseCSVLine(firstLine);

    // Pre-filter valid headers and indices
    const validMappings = rawHeaders
      .map((header, index) => ({ header: header?.trim(), index }))
      .filter(({ header }) => header && !header.startsWith("__EMPTY"));

    if (validMappings.length === 0) return [];

    const validHeaders = validMappings.map(({ header }) => header);
    const validIndices = validMappings.map(({ index }) => index);

    // Pre-allocate array with known size for better performance
    const parsedData = new Array(lines.length - 1);
    let dataIndex = 0;

    for (let i = 1; i < lines.length; i++) {
      const line = lines[i].trim();
      if (!line) continue;

      const values = parseCSVLine(line);
      const entry = {};

      // Use for loop instead of forEach for better performance
      for (let j = 0; j < validIndices.length; j++) {
        entry[validHeaders[j]] = values[validIndices[j]] || "";
      }

      parsedData[dataIndex++] = entry;
    }

    // Trim array to actual size
    parsedData.length = dataIndex;
    return parsedData;
  };

  const getData = () => {
    if (!isLoaded) {
      throw new Error("Les données ne sont pas encore chargées");
    }
    return data;
  };

  return {
    loadCSV,
    loadJSON,
    addEventListener,
    removeEventListener,
    parseCSV,
    unarchive,
    getData
  }
}

window.dataLoader = dataLoader();
export default window.dataLoader;
